import React from 'react'
import { Card } from '@fs/zion-ui'
import FamilyGroupCardContent from './FamilyGroupCardContent'

export default function SimpleCard({ children, ...cardContentProps }) {
  return (
    <Card>
      <FamilyGroupCardContent {...cardContentProps} />
      {children}
    </Card>
  )
}
